import React from 'react';
import { connect } from 'react-redux';

import usePermissions from 'hooks/usePermissions';
import ScrollableContainer from 'components/shared/scrollable';
import StickySidebar from 'components/shared/StickySidebar';
import Section from 'components/PathBuilder/Sidebar/Section';
import FeatureFlag from 'components/shared/FeatureFlag';
import EMAILS from 'constants/emails';
import { BetaFeedback } from 'components/BetaProgram';
import History from './History';
import Invite from './Invite';
import Archive from './Archive';
import Restore from './Restore';
import Copy from './Copy';
import ReminderEmails from './ReminderEmails';
import ConfirmationEmails from './ConfirmationEmails';
import GroupListingVisibility from './GroupListingVisibility';
import Rsvp from './Rsvp';
import Sharing from './Sharing';

const SingleSessionSidebar = ({ event }) => (
  <>
    <History event={event} />
    <GroupListingVisibility event={event} />
    <FeatureFlag features="events_in_development">
      <ConfirmationEmails />
    </FeatureFlag>
    <ReminderEmails />
  </>
);

const MultiSessionSidebar = ({ event, session }) => (
  <>
    {!session && <Sharing />}
    {session && <History event={session} />}
    <GroupListingVisibility event={event} sessionId={session?.id} />
    {!session && <Rsvp rsvpType={event.rsvp_type} />}
    {!session && (
      <FeatureFlag features="events_in_development">
        <ConfirmationEmails />
      </FeatureFlag>
    )}
    {!session && <ReminderEmails />}
    {!session && <History event={event} />}
    {session && (
      <div className="pl-24 mt-24">
        <BetaFeedback
          multiLineText
          recipient={EMAILS.EVENTS_FEEDBACK}
          feedbackWithFeatureName
          betaFeatureName="Multi-session Events"
        />
      </div>
    )}
  </>
);

export const Sidebar = ({
  isArchived,
  event,
  permissions,
  isMultiSession,
  sessionId,
  sessions,
}) => {
  const { isPermitted: canCreateOwnEvents } = usePermissions({
    type: 'in_person_training/event',
    action: 'create',
  });
  const currentSession = sessions?.find(
    session => Number(session.id) === Number(sessionId),
  );

  return (
    <StickySidebar className="PathBuilderSidebar">
      <ScrollableContainer maxHeight={null} hidden>
        <Section>
          {!sessionId && !isArchived && event.next_session && <Invite />}
          <div
            className={
              !isArchived && event.next_session
                ? 'copy-event-button-container d-f'
                : 'd-f'
            }
          >
            {!sessionId &&
              (canCreateOwnEvents || permissions.canEditAllEvents) && (
                <Copy event={event} />
              )}
            {!sessionId && !isArchived && <Archive />}
            {sessionId && <Archive session={currentSession} />}
            {!sessionId && isArchived && <Restore event={event} />}
          </div>
        </Section>
        {!isMultiSession && <SingleSessionSidebar event={event} />}
        {isMultiSession && (
          <MultiSessionSidebar event={event} session={currentSession} />
        )}
      </ScrollableContainer>
    </StickySidebar>
  );
};

const mapStateToProps = state => ({
  event: state.event,
  isArchived: state.event.is_archived,
  permissions: state.meta.permissions,
  isMultiSession: state.sessions.length > 1,
  sessions: state.sessions,
});

export default connect(mapStateToProps)(Sidebar);
